import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Avatar, AvatarFallback } from "@fronterahealth/frontera-ui-components/ui/avatar";

import { getAvatarColorClass } from "@components/QaReview/components/commentAuthor";

interface PersonAvatarProps {
  id: string;
  initials: string;
  size?: "default" | "sm" | "lg";
  className?: string;
  children?: React.ReactNode;
}

export const PersonAvatar: React.FC<PersonAvatarProps> = ({ id, initials, size, className, children }) => (
  <Avatar size={size} className={className}>
    <AvatarFallback className={cn("text-white", getAvatarColorClass(id))}>{initials}</AvatarFallback>
    {children}
  </Avatar>
);
